import { render, staticRenderFns } from "./suppliersCount.vue?vue&type=template&id=1e1adc86"
import script from "./suppliersCount.vue?vue&type=script&lang=js"
export * from "./suppliersCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports